import getCubeDimensions from "./get-cube-dimensions";

export default (state, cubeName) => {
  const dimensions = getCubeDimensions(state, cubeName);
  return dimensions.filter((d) => {
    return d.type === "time";
  });
};
